import {
    SCHEDULE_POLICY_KIND_LABELS,
    SchedulePolicyKind,
} from "@common/helpers/domains/accounting/schedulePolicyKind";
import {
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";

const POLICY_KINDS = Object.values(SchedulePolicyKind);

export function getPolicyKindFilterOptions(
    kinds: SchedulePolicyKind[],
): FilterMultiselectOption[] {
    return kinds.map((kind) => ({
        value: kind,
        label: SCHEDULE_POLICY_KIND_LABELS[kind],
    }));
}

export function isSchedulePolicyKind(
    value: FilterMultiselectValue,
): value is SchedulePolicyKind {
    return (
        typeof value === "string" && POLICY_KINDS.some((kind) => kind === value)
    );
}
